import React from 'react';
import { AnimatedSection } from '../../components/ui/AnimatedSection';
import { Button } from '../../components/ui/Button';
import { ArrowLeftIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function CortisolConnection() {
  return <main className="w-full pt-32 pb-24 bg-dark min-h-screen" data-id="element-642">
      <article className="max-w-3xl mx-auto px-6" data-id="element-643">
        <AnimatedSection data-id="element-644">
          <Link to="/blog" className="inline-flex items-center text-gold hover:text-white transition-colors mb-8 text-sm font-bold uppercase tracking-wider" data-id="element-645">
            <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-646" />
            Back to Insights
          </Link>

          <div className="mb-12" data-id="element-647">
            <span className="text-gold text-xs font-bold uppercase tracking-wider px-3 py-1 border border-gold/30 rounded-full mb-6 inline-block" data-id="element-648">
              Mindset
            </span>
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-649">
              Mindset and Metabolic Health: The Cortisol Connection
            </h1>
            <p className="text-xl text-muted leading-relaxed mb-6" data-id="element-650">
              Stress is not just mental — it directly impacts your metabolism.
            </p>
            <div className="flex items-center text-sm text-muted font-medium border-t border-border pt-6" data-id="element-651">
              <span data-id="element-652">Sep 15, 2025</span>
              <span className="mx-3" data-id="element-653">•</span>
              <span data-id="element-654">4 min read</span>
            </div>
          </div>
        </AnimatedSection>

        <AnimatedSection delay={0.2} className="prose prose-invert prose-lg max-w-none prose-headings:font-heading prose-headings:text-white prose-a:text-gold hover:prose-a:text-white prose-strong:text-white" data-id="element-655">
          <p data-id="element-656">
            Most people separate stress from physical health. Your body doesn't.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-657">
            What Stress Does to Your Body
          </h3>
          <p data-id="element-658">
            Chronic stress increases cortisol. When cortisol stays elevated, fat
            storage increases, muscle breaks down, sleep is disrupted, and
            hormones become unstable.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-659">
            Why This Matters
          </h3>
          <p data-id="element-660">
            You can do everything right, but if your nervous system is
            overwhelmed, your body will resist change.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-661">
            What This Looks Like
          </h3>
          <p data-id="element-662">
            You feel tired but wired, overwhelmed, unable to lose weight, and
            mentally drained.
          </p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-663">
            What This Means for You
          </h3>
          <p data-id="element-664">Your problem is not just physical. It's systemic.</p>

          <h3 className="text-2xl font-bold mt-10 mb-4 text-white" data-id="element-665">
            The BioShift Perspective
          </h3>
          <p data-id="element-666">
            We address stress patterns, behavioral habits, and internal pressure
            to restore balance.
          </p>
          <p className="text-xl font-medium text-gold italic mt-8" data-id="element-667">
            You don't fix stress with discipline. You fix it with awareness and
            structure.
          </p>
        </AnimatedSection>

        <AnimatedSection delay={0.3} data-id="element-668">
          <div className="mt-16 pt-12 border-t border-border text-center bg-surface p-10 rounded-lg" data-id="element-669">
            <h3 className="text-2xl font-bold text-white mb-4 font-heading" data-id="element-670">
              Ready to restore balance?
            </h3>
            <p className="text-muted mb-8 max-w-lg mx-auto" data-id="element-671">
              Learn how our holistic approach addresses both the physical and
              mental barriers to your health.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-672">
              Apply for Coaching
            </Button>
          </div>
        </AnimatedSection>
      </article>
    </main>;
}